import { SET_POST_IN_STORE,SET_POSTS_IN_STORE } from '../constants/types';

const initialState = {
    post : {},
    posts: []
}

export default function( state= initialState , action ){
    switch (action.type){
        case SET_POST_IN_STORE:
            return{
                ...state,
                post: action.payload
            }
        case SET_POSTS_IN_STORE:
            return{
                ...state,
                posts: action.payload
            }
        default:
            return state;
    }
}